module.exports = __webpack_public_path__ + "img/japan.a11dc965.svg";